export const environment = {
    environmentName: 'PROD',
    production: true,
    isDebugMode: true,
    apiHost: 'https://appelsaprojetsapi.fondation-arc.org',
    translations: ['fr', 'en'],
    extantions: {
        documents: ['pdf'],
        images: ['png', 'jpg', 'gif', 'jpeg'],
    },
    annulationRequetesRouteChange: true,
    annulationRequetesDouble: false,
    sentryDsn: 'https://942a0cb373f3414e9d6fafebc8cd3872@sentry.io/1827552',
    sentryEnvironment: 'PROD',
    versionCheckUrl: 'https://appelsaprojets.fondation-arc.org/version.json',
    versionID:'09-10-2026__07:23__1791530582268',
    checkVersion: true,
    financeUrl: 'https://financement.fondation-arc.org',
};
